import script from "./joinList.vue?vue&type=script&setup=true&lang=js"
export * from "./joinList.vue?vue&type=script&setup=true&lang=js"

import "./join.css?vue&type=style&index=0&id=06340bde&scoped=true&lang=css"
import "./joinList.vue?vue&type=style&index=1&id=06340bde&lang=css"

import exportComponent from "D:\\work\\gw-sh\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06340bde"]])

export default __exports__